<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('monthlyOvertime.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label required">
                    {{ $t('monthlyOvertime.employeeName') }}
                    <i class="fa fa-spinner spin" v-if="fetchEmp"></i>
                  </label>
                  <ts-search-select
                    v-model="model.employee_id"
                    :options="employees"
                    :class="{ 'is-invalid': errors.has('employee_id') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('employee_id')">
                    {{ errors.first('employee_id') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label required">
                    {{ $t('monthlyOvertime.otDate') }}
                  </label>
                  <ts-date-picker-input
                    v-model="model.ot_date"
                    format="DD-MM-YYYY"
                    :class="{ 'is-invalid': errors.has('ot_date') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('ot_date')">
                    {{ errors.first('ot_date') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label required">
                    {{ $t('monthlyOvertime.cycleYear') }}
                  </label>
                  <ts-date-picker-input
                    v-model="model.cycle_year"
                    format="YYYY"
                    :class="{ 'is-invalid': errors.has('cycle_year') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('cycle_year')">
                    {{ errors.first('cycle_year') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label required">
                    {{ $t('monthlyOvertime.cycleMonth') }}
                  </label>
                  <ts-date-picker-input
                    v-model="model.cycle_month"
                    format="MM"
                    :class="{ 'is-invalid': errors.has('cycle_month') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('cycle_month')">
                    {{ errors.first('cycle_month') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label required">
                    {{ $t('monthlyOvertime.timeFrom') }}
                  </label>
                  <ts-time-picker-input
                    v-model="model.time_from"
                    :use24Hour="true"
                    :class="{ 'is-invalid': errors.has('time_from') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('time_from')">
                    {{ errors.first('time_from') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label required">
                    {{ $t('monthlyOvertime.timeTo') }}
                  </label>
                  <ts-time-picker-input
                    v-model="model.time_to"
                    :use24Hour="true"
                    :class="{ 'is-invalid': errors.has('time_to') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('time_to')">
                    {{ errors.first('time_to') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label required">
                    {{ $t('monthlyOvertime.break') }}
                  </label>
                  <input
                    type="number"
                    step="any"
                    v-model.number="model.break"
                    :class="{ 'is-invalid': errors.has('break') }"
                    class="form-control"
                  />
                  <div class="invalid-feedback" v-if="errors.has('break')">
                    {{ errors.first('break') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label">
                    {{ $t('monthlyOvertime.remark') }}
                  </label>
                  <textarea
                    v-model.trim="model.remarks"
                    :class="{ 'is-invalid': errors.has('remarks') }"
                    class="form-control"
                    rows="1"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('remarks')">
                    {{ errors.first('remarks') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">
              {{ $t('button.cancel') }}
            </ts-button>
            ​<ts-button
              outline
              color="primary"
              class="ml-2 primary"
              :waiting="savingAddNew"
              @click.prevent="saveAddNew"
              v-if="editData === undefined"
              >{{ $t('button.saveAddNew') }}</ts-button
            >
            ​<ts-button
              class="btn-primary ml-2"
              :waiting="saving"
              @click.prevent="store"
              v-if="editData === undefined"
              >{{ $t('button.save') }}</ts-button
            >
            ​<ts-button class="btn-primary ml-2" :waiting="saving" @click.prevent="update" v-if="editData">{{
              $t('button.update')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'monthly-overtime-form',
  props: ['editData'],
  data() {
    return {
      model: {
        record_id: '',
        employee_id: '',
        cycle_year: '',
        cycle_month: '',
        ot_date: '',
        time_from: '',
        time_to: '',
        break: '',
        remarks: ''
      },
      fetchEmp: false,
      savingAddNew: false,
      saving: false,
      errors: new Errors()
    }
  },
  created() {
    this.fetchEmployeeList()
  },
  computed: {
    employees() {
      return this.$store.state.hr.monthlyOvertime.employees.map(el => ({
        value: el.employee_id,
        text: el.employee_name_en
      }))
    }
  },
  methods: {
    fetchEmployeeList() {
      this.fetchEmp = true
      this.$store
        .dispatch('hr/monthlyOvertime/getEmployee')
        .then(response => {
          this.fetchEmp = false
          this.setEditData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetchEmp = false
        })
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/monthlyOvertime/update', {
          id: this.editData.record_id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/monthlyOvertime/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.savingAddNew = true
      this.$store
        .dispatch('hr/monthlyOvertime/store', this.model)
        .then(response => {
          this.savingAddNew = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.clearInput()
        })
        .catch(error => {
          this.savingAddNew = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    fetchData() {
      this.$store.dispatch('hr/monthlyOvertime/fetch').catch(error => {
        this.$toasted.error(error.message)
      })
    },
    setEditData() {
      if (!_.isEmpty(this.editData)) {
        this.model = {
          record_id: this.editData.record_id,
          employee_id: this.editData.employee_id,
          cycle_year: this.editData.cycle_year,
          cycle_month: this.editData.cycle_month,
          ot_date: this.editData.ot_date,
          time_from: this.editData.time_from,
          time_to: this.editData.time_to,
          break: this.editData.break,
          remarks: this.editData.remarks
        }
      }
    },
    clearInput() {
      this.model = {
        record_id: '',
        employee_id: '',
        cycle_year: '',
        cycle_month: '',
        ot_date: '',
        time_from: '',
        time_to: '',
        break: '',
        remarks: ''
      }
    }
  }
}
</script>
